import React, { useState } from 'react';
import '../styles/Certificates.css';

const Certificates = () => {
  const [type, setType] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    class_name: '',
    dob: '',
    father_name: '',
    issued_date: ''
  });
  const [generated, setGenerated] = useState(false);

  const handleSelect = (certificateType) => {
    setType(certificateType);
    setFormData({ name: '', class_name: '', dob: '', father_name: '', issued_date: '' });
    setGenerated(false);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleGenerate = (e) => {
    e.preventDefault();
    setGenerated(true);
  };

  return (
    <div className="certx-wrapper">
      <h2 className="certx-heading">🎓 Certificates</h2>

      <div className="certx-buttons">
        <button
          onClick={() => handleSelect('tc')}
          className={type === 'tc' ? 'certx-btn active' : 'certx-btn'}
        >
          Transfer Certificate
        </button>
        <button
          onClick={() => handleSelect('character')}
          className={type === 'character' ? 'certx-btn active' : 'certx-btn'}
        >
          Character Certificate
        </button>
      </div>

      {type && (
        <form className="certx-form" onSubmit={handleGenerate}>
          <div className="certx-form-group">
            <label>Full Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          </div>
          <div className="certx-form-group">
            <label>Class Name</label>
            <input type="text" name="class_name" value={formData.class_name} onChange={handleChange} required />
          </div>
          <div className="certx-form-group">
            <label>Date of Birth</label>
            <input type="date" name="dob" value={formData.dob} onChange={handleChange} required />
          </div>
          <div className="certx-form-group">
            <label>Father's Name</label>
            <input type="text" name="father_name" value={formData.father_name} onChange={handleChange} required />
          </div>
          <div className="certx-form-group">
            <label>Date of Issue</label>
            <input type="date" name="issued_date" value={formData.issued_date} onChange={handleChange} required />
          </div>
          <button type="submit" className="certx-submit">Generate Certificate</button>
        </form>
      )}

      {generated && (
        <div className="certx-preview">
          <h3>{type === 'tc' ? 'Transfer Certificate' : 'Character Certificate'}</h3>
          <p>This is to certify that <strong>{formData.name}</strong>, son/daughter of <strong>{formData.father_name}</strong>, was a student of our institution in class <strong>{formData.class_name}</strong>.</p>

          {type === 'tc' && (
            <p>He/She has applied for a Transfer Certificate. All dues have been cleared and we have no objection in issuing the certificate.</p>
          )}

          {type === 'character' && (
            <p>He/She bears good moral character and has shown disciplined conduct during their stay in the school.</p>
          )}

          <p>Date of Birth (as per school record): <strong>{formData.dob}</strong></p>
          <p>Date of Issue: <strong>{formData.issued_date}</strong></p>

          <div className="certx-signature">
            <em>Principal / Headmaster</em>
          </div>
        </div>
      )}
    </div>
  );
};

export default Certificates;
